const flowState = {
  flowSummary: null,
  loading: false,
};

export const flowSummaryReducer = (state = flowState, action) => {
  switch (action.type) {
    case "GET_FLOW_SUMMARY":
      return {
        ...state,
        flowSummary: action.payload,
        loading: action.loader,
      };
    case "GET_RECEIPTS_DISTRIBUTION":
      return {
        ...state,
        flowSummary: state.flowSummary
          ? { ...state.flowSummary, ...action.payload }
          : action.payload,
        loading: action.loader,
      };
    case "GET_MAJOR_OUTFLOWS":
      return {
        ...state,
        flowSummary: state.flowSummary
          ? { ...state.flowSummary, ...action.payload }
          : action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const pdcState = {
  pdcRadar: null,
  loading: false,
};

export const pdcRadarReducer = (state = pdcState, action) => {
  switch (action.type) {
    case "GET_PDC_RADAR":
      return {
        ...state,
        pdcRadar: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const investmentState = {
  investmentLiabilities: null,
  loading: false,
};

export const investmentLiabilitiesReducer = (state = investmentState, action) => {
  switch (action.type) {
    case "GET_INVESTMENT_LIABILITIES":
      return {
        ...state,
        investmentLiabilities: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const arApAgingState = {
  arApAgingSummary: null,
  loading: false,
};

export const arApAgingSummaryReducer = (state = arApAgingState, action) => {
  switch (action.type) {
    case "GET_AR_AP_AGING_SUMMARY":
      return {
        ...state,
        arApAgingSummary: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const draftVouchersState = {
  draftVouchers: null,
  loading: false,
};

export const draftVouchersReducer = (state = draftVouchersState, action) => {
  switch (action.type) {
    case "GET_DRAFT_VOUCHERS":
      return {
        ...state,
        draftVouchers: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};
